var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"timer-component"},[(!_vm.hideTimer)?_c('div',{staticClass:"timer-display",class:[_vm.phaseClass, { 'blink-overtime': _vm.shouldBlinkOvertime }],style:(_vm.timerStyle)},[_vm._v("\n    "+_vm._s(_vm.formattedTime)+"\n  ")]):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-312183bc","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ontime/OntimeTimer.vue
// module id = null
// module chunks = 